"use client";

import { c as _c } from "react/compiler-runtime";
import type { Route } from "next";
import Image from "next/image";
import Link from "next/link";
import { useContext } from "react";
import { twMerge } from "tailwind-merge";
import VerticalCurve from "@/components/vertical-curve";
import { isBurgerActiveContext } from "@/context/is-burger-active";
import { CardLinkProps } from "@/TS/Interfaces/global_interfaces";
export default function CardLink(t0) {
  const $ = _c(17);
  const {
    img,
    verticalCurveClass,
    href,
    imgAlt,
    imgClassName,
    target,
    title,
    className,
    contentClassName,
    children,
    icon
  } = t0;
  const [, setIsActive] = useContext(isBurgerActiveContext);
  const t1 = `rounded h-44 text-center flex flex-col items-center overflow-hidden mb-2 ${className}`;
  let t2;
  if ($[0] !== t1) {
    t2 = twMerge(t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children || $[3] !== contentClassName || $[4] !== href || $[5] !== icon || $[6] !== img || $[7] !== imgAlt || $[8] !== imgClassName || $[9] !== setIsActive || $[10] !== target || $[11] !== title || $[12] !== verticalCurveClass) {
    t3 = href ? <Link onClick={() => setIsActive(false)} href={href as Route} className="flex h-full group w-full max-w-96" target={target}><div className={twMerge(`w-[60%] rounded-l min-w-[60%] relative overflow-hidden ${imgClassName}`)}>{icon ? <div className="h-full bg-rencontres-blue px-2">{icon}</div> : <div className="relative w-[105%] h-full transition-all group-hover:translate-x-[-5%]"><Image src={img ?? "/img/club-default-cover.jpg"} alt={imgAlt ?? ""} className="min-w-full w-full h-full aspect-[17/9] object-cover object-left" width={152} height={121} /></div>}<div className="absolute h-full top-0 right-0 w-fit"><VerticalCurve className={verticalCurveClass ?? ""} /></div></div><div className={twMerge(`bg-primary rounded-r flex justify-center items-center underline decoration-1 underline-offset-2 text-white py-6 w-full px-2 font-light group-hover:font-normal text-sm ${contentClassName}`)}>{children} {title}</div></Link> : <div className="h-full w-full max-w-96 relative overflow-hidden rounded"><Image src={img ?? "/img/club-default-cover.jpg"} alt={imgAlt ?? ""} className="w-full h-full object-cover" width={152} height={121} /></div>;
    $[2] = children;
    $[3] = contentClassName;
    $[4] = href;
    $[5] = icon;
    $[6] = img;
    $[7] = imgAlt;
    $[8] = imgClassName;
    $[9] = setIsActive;
    $[10] = target;
    $[11] = title;
    $[12] = verticalCurveClass;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== t2 || $[15] !== t3) {
    t4 = <div className={t2}>{t3}</div>;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
}